import React from "react";
import { v4 as uuidv4 } from "uuid";

import History from "../../utilities/History";
import Landing from "./Landing";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import productActions from "../../flux/actions/ProductActions";
import productListStore from "../../flux/stores/product/ListStore";

import { IProductViewData, defaultProductData } from "../../models/product/ProductViewData";
import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import * as CONSTANTS from "../../utilities/Constants";

import { Translation } from "react-i18next";

import './product.sass';
import IActionHeaderFormData, { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import productByIdStore from "../../flux/stores/product/ByIdStore";
import productDeleteStore from "../../flux/stores/product/DeleteStore"
import SidebarLayout from "../shared/SidebarLayout";
import SidebarTitle from "../shared/SidebarTitle";
import { ProductFormData } from "../../models/product/ProductFormData";
import { defaultGradeBasicData } from "../../models/grade/GradeBasicData";
import NoDataFound from "../shared/NoDataFound";
import SidebarCreate from "../shared/SidebarCreate";
import triggerNotifications from "../../utilities/TriggerNotifications";
import productFormStore from "../../flux/stores/product/FormStore";
import NoDataOnboarding from '../shared/NoDataOnboarding';
import loadingActions from '../../flux/actions/LoadingActions';
import { Spinner } from "@abb/abb-common-ux-react";

import Sidebar from "../sharedNew/sidebarCommon/sidebar";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";
import '../sharedNew/sidebarCommon/sidebar.sass';
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import productDisableStore from "../../flux/stores/product/DisableStore";
import productEnableStore from "../../flux/stores/product/EnableStore";
import IdGenerator from "../../utilities/GenerateId";
interface IIndexState {
  activeId: string;
  activeItem: IProductViewData;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
  isClonedCreated: boolean;
  inputProductName: string;
  showPopup: boolean;
  inputCode: string;
  isData: boolean;
  nameError: boolean;
  codeError: boolean;
  buttonDisabled: boolean;
  searchValue: string;
  collapseSidebar: boolean;
  isLoading: boolean;
}

export default class Index extends React.Component<{ location: any }, IIndexState> {
  private _mount = false;
  private _reload = true;
  private _id = "";
  private _isSelectedLink = false;
  private _searchId = "";
  private _listData: ISidebarDetail[] = [];
  private _activeItem: IProductViewData;
  private _activeId: string;
  private _message: string[];
  private _isValid: boolean = false;
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listRef: any;
  private productList: any = [];

  constructor(props: { location: any }) {
    super(props);
    const searchName = this.props.location &&  this.props.location.state && this.props.location.state.searchName  ? this.props.location.state.searchName : '';
    this._mount = false;
    this._listRef = React.createRef();
    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue: searchName || "",
      activeItem: defaultProductData,
      listData: [],
      isFullSidebarVisible: true,
      isClonedCreated: false,
      inputProductName: "",
      showPopup: false,
      inputCode: "",
      isData: true,
      nameError: false,
      codeError: false,
      buttonDisabled: true,
      isLoading: false
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    History.replace({ state: {} })
    this._mount = true;

    productFormStore.on(CONSTANTS.CHANGE_EVENT, state => {
      if (this._mount) {
        this._message = state.messages;
      }
    })

    /// Set Add Button Event
    const addRequest = {
      moduleName: CONSTANTS.MODULE_PRODUCT,
      createData: new ProductFormData(uuidv4(), false, "", "", "", "", defaultGradeBasicData, [], [], [])
    } as IActionHeaderFormData;
    actionHeaderActions.common(addRequest).then();

    if (this.props.location.state && this.props.location.state.isReloadFirst !== undefined) {
      this._reload = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;

      const state = { ...this.props.location.state };
      delete state.isReloadFirst;
      delete state.id;
      History.replace({ ...History.location, state });
    }

    if (
      this.props.location.state &&
      this.props.location.state.isSelectedLink !== undefined
    ) {
      this._isSelectedLink = this.props.location.state.isSelectedLink;
      this._searchId = this.props.location.state.id;
    }

    productDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reload = state.reload
        setTimeout(() => {
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    productListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {

        this._listData = [];
        if (state.productDataList.currentPage === state.productDataList.totalPages || state.productDataList.totalRecords === 0) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.productDataList.result as IProductViewData[];
        this.productList = state.productDataList.result as IProductViewData[];
        const items: ISidebarDetail[] = [];
        data.forEach(element => {
          items.push(new SidebarDetail(element.id, element.name));
        });

        this._listData = items;
      }
    });

    productByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({
          activeItem: state.productData,
          activeId: state.productData.id
        });
      }
    });

    productDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
      this._reload = state.reload;
      setTimeout(() => {
        this.getAll();
      }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    productEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
       if (this._mount) {
       this._reload = state.reload;
       setTimeout(() => {
         this.getAll();
       }, CONSTANTS.NOTIFICATION_TIMEOUT);
       }
     });



    this.getAll();
  }

  private getAll() {
    loadingActions.setLoading(true);
    this.setState({isLoading: true})
    if (this.state.isClonedCreated) {
      this._page = 1;
    }
    productActions.getAll(false, this._page, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
      this.setState({
        listData: this._listData,
        isClonedCreated: false
      }, () => {
        loadingActions.setLoading(false);
        this.setState({isLoading: false})
        const firstItem = this.state.listData[0];
        if (this._reload) {
          if (this.state.listData.length > 0) {
            this.triggerGetById(firstItem.id);
          } else {
            const data: IActionHeaderEditData = {
              moduleName: CONSTANTS.MODULE_PRODUCT,
              editData: {},
              deleteTitle: "",
              deleteId: "",
              isEnableViewAll: true,
              deleteRequestId: uuidv4(),
              deleteMessage: ""
            };
            actionHeaderActions.edit(data).then();
          }
        }
        else {
          this.triggerGetById(this._id);
        }
        if(this.state.searchValue){
          this.onsearch(this.state.searchValue);
        }
      });
    }).catch(() => {
      loadingActions.setLoading(false)
      this.setState({isLoading: false})
    });
  }


  private triggerGetById(id: string) {
    productActions.getById(id).then(() => {
      const receivedData = this.state.activeItem;

      const editData = new ProductFormData(uuidv4(), true, receivedData.id, receivedData.name, receivedData.description, receivedData.code,
        receivedData.grade, receivedData.measuredProperties, receivedData.keyedInProperties, receivedData.calculatedProperties);

      const data: IActionHeaderEditData = {
        moduleName: CONSTANTS.MODULE_PRODUCT,
        editData,
        deleteTitle: receivedData.name,
        deleteId: receivedData.id,
        deleteRequestId: uuidv4(),
        deleteMessage: receivedData.name
      };

      actionHeaderActions.edit(data).then();
    });
  }

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  }

  public setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "")
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (val.trim() && !rgFile.test(val)) {
      this.setState({ nameError: false, inputProductName: val }, this.validate)
    } else {
      this.setState({ nameError: true, inputProductName: val }, this.validate)
    }
  }

  public setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "")
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (val.trim() === "" || (!rgFile.test(val) && val.trim())) {
      this.setState({ codeError: false, inputCode: val }, this.validate)
    } else {
      this.setState({ codeError: true, inputCode: val }, this.validate)
    }
  }

  public onActivate = () => {
    this.setState({
      showPopup: true
    });
  }

  public onDeactivate = () => {
    this.setState({
      showPopup: false
    });
  }

  public onSave = (e: any, val: boolean) => {
    if (e !== null) {
      if (e.keyCode === 13) {
        this.setState({
          showPopup: false,
        });
        const productData = this.state.activeItem;
        if (this._isValid) {
          const tempName = this.state.inputProductName.replace(/ +(?= )/g, '').trim();
          this.setState({
            inputProductName: tempName
          }, () => {
            const productBody = new ProductFormData(uuidv4(), true, productData.id, this.state.inputProductName, productData.description, this.state.inputCode,
              productData.grade, productData.measuredProperties, productData.keyedInProperties, productData.calculatedProperties);
            productActions.post(productBody).then(() => {
              triggerNotifications.success(this._message).then();
              this.setState({
                inputProductName: "",
                inputCode: "",
                buttonDisabled: true,
                isClonedCreated: true
              })
              this._listData = [];
              this.getAll();
              this._listRef.current.scrollTop = 0;
            }).catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
              this.setState({
                inputProductName: "",
                inputCode: "",
                buttonDisabled: true,
                isClonedCreated: false
              })
            })
          })
        }
      }
    } else {
      this.setState({
        showPopup: false,
      });
      const productData = this.state.activeItem;
      if (this._isValid) {
        const tempName = this.state.inputProductName.replace(/ +(?= )/g, '').trim();
        this.setState({
          inputProductName: tempName
        }, () => {
          const productBody = new ProductFormData(uuidv4(), true, productData.id, this.state.inputProductName, productData.description, this.state.inputCode,
            productData.grade, productData.measuredProperties, productData.keyedInProperties, productData.calculatedProperties);
          productActions.post(productBody).then(() => {
            triggerNotifications.success(this._message).then();
            this.setState({
              inputProductName: "",
              inputCode: "",
              buttonDisabled: true,
              isClonedCreated: true
            })
            this._listData = [];
            this.getAll();
            this._listRef.current.scrollTop = 0;
          }).catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
            this.setState({
              inputProductName: "",
              inputCode: "",
              buttonDisabled: true,
              isClonedCreated: false
            })
          })
        })
      }
    }

  }

  validate(): void {
    if (!this.state.codeError && !this.state.nameError &&
      this.state.inputProductName.trim() && this.state.inputProductName !== "") {
      this._isValid = true;
      this.setState({
        buttonDisabled: false
      })
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true
      })
    }
  }

  public onCreateClick = () => {
    const createData = new ProductFormData(uuidv4(), false, "", "", "", "", defaultGradeBasicData, [], [], []);
    History.push(CONSTANTS.PRODUCT_CREATE_URL, createData)
  }

  public viewAll() {
    History.push(CONSTANTS.PRODUCT_VIEW_ALL);
  }

  onCollapseSidebar = () => {

    this.setState({
      collapseSidebar: !this.state.collapseSidebar
    })
  }

  public onsearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      productActions.getAll(false, 1, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, value).then(() => {
        loadingActions.setLoading(false);
        this.setState({ listData: this._listData, searchValue: value }
          , () => {
            const firstItem = this.state.listData[0];
            if (this.state.listData.length > 0) {
              if(this._isSelectedLink){
                this.triggerGetById(this._searchId);
              }else{
                this.triggerGetById(firstItem.id);
              }
            }
          })
      })
    } else {
      this.setState({ searchValue: value })
    }
  }

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    productActions.getAll(false, this._page, CONSTANTS.PAGE_SIZE, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, this.state.searchValue).then(() => {
      loadingActions.setLoading(false);
      const data = [...this.state.listData, ...this._listData];
      this.setState({ listData: data });
    }).catch(() => loadingActions.setLoading(false));
  }



  public render() {
    return (
      <Translation>
        {
          t => <div className="layout-margin">
            {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 
            (<>{(this.state.listData.length === 0 && this.state.searchValue.length === 0) ?
              <NoDataOnboarding moduleName={CONSTANTS.MODULE_PRODUCT} onCreateClick={this.onCreateClick} authKey={CONSTANTS.AUTHKEY_PRODUCT}/> :

              <React.Fragment>
                {
                  !this.state.collapseSidebar ?
                    <div>
                      <Sidebar
                      authKey={CONSTANTS.AUTHKEY_PRODUCT}
                        onCollapseSidebar={this.onCollapseSidebar}
                        searchValue={this.state.searchValue}
                        onSearch={this.onsearch}
                        onCreateClick={this.onCreateClick}
                        viewAll={this.viewAll}

                        showCloneIcon={true}
                        setName={(val: string) => this.setName(val)}
                        inputName={this.state.inputProductName} isShowPopup={this.state.showPopup}
                        module={CONSTANTS.MODULE_PRODUCT} setCode={(val: string) => this.setCode(val)}
                        inputCode={this.state.inputCode}
                        nameError={this.state.nameError}
                        codeError={this.state.codeError}
                        isButtonDisabled={this.state.buttonDisabled}
                        onActivate={this.onActivate} onSave={this.onSave} onDeactivate={this.onDeactivate}
                      >
                        <SidebarList
                          onSelectLink={this.onSelectLink}
                          listData={this.state.listData}
                          activeId={this.state.activeId}
                          fetchMore={this.fetchMore}
                          hasMore={this._hasMore}
                          module={CONSTANTS.MODULE_PRODUCT}
                        >
                        </SidebarList>
                      </Sidebar>
                    </div>
                    :
                    <SidebarCollapse 
                    authKey={CONSTANTS.AUTHKEY_PRODUCT}
                    onCollapseSidebar={this.onCollapseSidebar} 
                    onCreateClick={this.onCreateClick}
                    viewAll={this.viewAll}

                    setName={(val: string) => this.setName(val)}
                    inputName={this.state.inputProductName} isShowPopup={this.state.showPopup}
                    module={CONSTANTS.MODULE_PRODUCT} setCode={(val: string) => this.setCode(val)}
                    inputCode={this.state.inputCode}
                    nameError={this.state.nameError}
                    codeError={this.state.codeError}
                    isButtonDisabled={this.state.buttonDisabled}
                    onActivate={this.onActivate} onSave={this.onSave} onDeactivate={this.onDeactivate}
                    showCloneIcon={true}
                     ></SidebarCollapse>
                }

                <div className={!this.state.collapseSidebar ? "main-layout ml-3 no-padding" : "main-full-layout float-right"}>
                  <Landing />
                </div>
              </React.Fragment>

            }</>)}
          </div>
        }
      </Translation>
    );
  }
}
